import { Injectable } from '@angular/core';
import { SharedGenericSingletonService } from './shared-generic-singleton.service';
import { ICustomerGenericService, IHIPGenericService } from '../interfaces';
import { Endpoints as HIPEndpoints, UserRightsService as HIPAuth } from '@huge-monorepo/hip/services';
import { Endpoints as CustomerEndpoints } from '@huge-monorepo/portal/config';
import { UserRightsService as CustomerAuth } from '@huge-monorepo/portal/services';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SharedUsageDataSourceSingletonService {
  private genericService: SharedGenericSingletonService<any> | null = null;
  private authService: HIPAuth | CustomerAuth
  public dataSource: "CDR" | "Radius" = "CDR";

  constructor() { }

  setGenericService(service: SharedGenericSingletonService<any>): void {
    this.genericService = service;
  }

  startTimer(): void {
    if (this.authService != null && this.authService.IsLoggedIn()) {
      if (this.genericService == null) {
        console.error('Generic service is not set');
      } else {

        this.genericService?.service.GET(this.genericService.getEndpoints().GET_USAGE_DATA_SOURCE).subscribe({
          next: (data: HttpResponse<any>) => {
            this.dataSource = data.body.UsageDataSource;
            console.log(this.dataSource);

          },
          error: (error) => {
            console.error('Error occurred:', error);
          }
        });

        setTimeout(() => {
          this.startTimer();
        }, 300000);
      }
    }
  }

  setAuthService(service: HIPAuth | CustomerAuth): void {
    this.authService = service;
  }
}
